module.exports = __webpack_public_path__ + "img/yxrwgj-icon.c6bfc50.svg";